import { Stack } from 'expo-router';

export default function LearnLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="course/[id]" />
      <Stack.Screen name="workspace" />
      <Stack.Screen name="creator/index" />
      <Stack.Screen name="creator/[courseId]" />
      <Stack.Screen name="creator/manage/[worldId]" />
      <Stack.Screen name="creator/edit/[worldId]" />
      <Stack.Screen name="path/create" />
      <Stack.Screen name="path/generate" />
      <Stack.Screen name="path/[slug]" />
      <Stack.Screen name="path/[slug]/home" />
      <Stack.Screen name="path/[slug]/practice/index" />
      <Stack.Screen name="path/[slug]/practice/session" />
      <Stack.Screen name="path/[slug]/exam/index" />
      <Stack.Screen name="path/[slug]/exam/session" />
      <Stack.Screen name="path/[slug]/exam/result" />
      <Stack.Screen name="path/[slug]/review/index" />
      <Stack.Screen name="path/[slug]/review/[attemptId]" />
      <Stack.Screen name="path/[slug]/review/retry/[attemptId]" />
      <Stack.Screen name="path/[slug]/reverse/index" />
      <Stack.Screen name="path/[slug]/reverse/session" />
      <Stack.Screen name="path/[slug]/reverse/result" />
      <Stack.Screen name="path/[slug]/lesson/[lessonId]" />
      <Stack.Screen name="path/[slug]/summary/[lessonId]" />
      <Stack.Screen name="path/profile" />
      <Stack.Screen name="path/[slug]/tutor" />
      <Stack.Screen name="path/[slug]/flashcards" />
      <Stack.Screen name="path/[slug]/study-plan" />
      <Stack.Screen name="path/[slug]/community" />
    </Stack>
  );
}
